import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './pages/Home/Home';
import Montagem from './pages/Montagem/Montagem'
import Pesquisa from './pages/Pesquisa/Pesquisa'
import Produto from './pages/Produto/Produto'
import NavBar from './components/Navegação/NavBar/NavBar';
import Footer from './components/Navegação/Footer/Footer'
import SobreNos from './pages/SobreNos/SobreNos';
import { useState } from 'react';

function App() {

  const [isLogged, setIsLogged] = useState(false)
  const [email, setEmail] = useState('')

  return (
    <Router>
      <div className="screen-container">
        <NavBar isLogged={isLogged} setIsLogged={setIsLogged} setEmail={setEmail} email={email} />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/Montagem' element={<Montagem isLogged={isLogged} email={email} />} />
          <Route path='/Pesquisa/:pesquisa' element={<Pesquisa />} />
          <Route path='/Produto/:pesquisa/:id' element={<Produto />} />
          <Route path='/SobreNos' element={<SobreNos />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
